import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { AURORA } from '../data/runTheme';

interface RunnerControlsProps {
  paused: boolean;
  onPause: () => void;
  onResume: () => void;
  onStop: () => void;
}

const pillBase: React.CSSProperties = {
  fontSize: '1rem',
  fontWeight: 500,
  padding: '0.75rem 2rem',
  borderRadius: '999px',
  cursor: 'pointer',
  border: '1px solid transparent',
  transition: 'filter 0.15s ease, transform 0.1s ease',
};
const translucent: React.CSSProperties = {
  ...pillBase,
  background: 'rgba(255,255,255,0.12)',
  border: '1px solid rgba(255,255,255,0.28)',
  color: AURORA.textPrimary,
};
const stopStyle: React.CSSProperties = {
  ...pillBase,
  background: 'rgba(255,255,255,0.16)',
  color: AURORA.textPrimary,
};
const resumeStyle: React.CSSProperties = {
  ...pillBase,
  background: AURORA.accent,
  color: '#ffffff',
};

// Hover/active feedback for the touch-first pills (inline styles can't do
// :hover/:active, so a tiny scoped stylesheet handles it).
const pillFeedback = `.btb-pill:hover{filter:brightness(1.12)} .btb-pill:active{transform:scale(0.97)}`;

const RunnerControls: React.FC<RunnerControlsProps> = ({ paused, onPause, onResume, onStop }) => {
  const { t } = useLanguage();

  if (paused) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem' }}>
        <style>{pillFeedback}</style>
        <span style={{ fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.08em', color: AURORA.textSecondary }}>
          {t('protocols.paused')}
        </span>
        <div style={{ display: 'flex', gap: '0.75rem' }}>
          <button className="btb-pill" onClick={onResume} style={resumeStyle}>{t('protocols.resume')}</button>
          <button className="btb-pill" onClick={onStop} style={stopStyle}>{t('protocols.stop')}</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', gap: '0.75rem' }}>
      <style>{pillFeedback}</style>
      <button className="btb-pill" onClick={onPause} style={translucent}>{t('protocols.pause')}</button>
      <button className="btb-pill" onClick={onStop} style={stopStyle}>{t('protocols.stop')}</button>
    </div>
  );
};

export default RunnerControls;
